<!-- 空调电 -->
<style lang="scss" scoped>
.water-content {
  display: flex;
  position: relative;
  margin: 20px;
  .left-content {
    width: 156px;
    height: 92px;
    .top-num {
      display: flex;
      width: 156px;
      height: 55px;
      align-items: baseline;
      .num {
        font-weight: 500;
        font-size: 48px;
        line-height: 55px;
        width: 74px;
        color: #2d82ff;
        font-family: "dina";
      }
      .unit {
        position: absolute;
        top: -47px;
        left: 113px;
        margin-left: 4px;
        font-weight: 500;
        font-size: 20px;
        line-height: 23px;
        color: rgba(255, 255, 255, 0.8);
        font-family: "dina";
      }
    }
    .bot-name {
      margin-top: 10px;
      font-weight: 500;
      font-size: 18px;
      line-height: 27px;
      color: #fff;
    }
  }
  .right-chart {
    margin-left: 20px;
    width: 200px;
    height: 91px;
  }
}
</style>

<template>
  <custom-dayPlane
    title="其他"
    :iconImg="require('@/assets/public/other.png')"
    @changeDay="changeDay"
  >
    <div class="water-content">
      <div class="left-content">
        <div class="top-num">
          <div class="num">{{ airNum(air[timeValue]) }}</div>
          <!-- <div class="unit">{{ eleUnit }}</div> -->
        </div>
        <div class="bot-name">{{ map[timeValue] }}总量 ({{ eleUnit }})</div>
      </div>
      <div class="right-chart">
        <custom-charts :dataList="dataList" :timer="timeValue"></custom-charts>
      </div>
    </div>
  </custom-dayPlane>
</template>

<script>
export default {
  data() {
    return {
      timeValue: "day",
      dataList: {
        x: [],
        y: [],
      },
      map: {
        day: "当日",
        month: "当月",
        year: "当年",
      },
    };
  },
  props: {
    air: Object,
  },
  watch: {
    air() {
      if (this.air?.historicalDay) {
        this.getChartData();
      }
    },
  },
  computed: {
    eleUnit() {
      if (this.timeValue != "day") {
        return "mWh";
      } else {
        return "kWh";
      }
    },
  },
  methods: {
    airNum(value) {
      if (value) {
        if (this.timeValue != "day") {
          return (value / 1000).toFixed(2);
        } else {
          return value;
        }
      } else {
        return "-";
      }
    },
    loadData(value, first, end) {
      this.dataList = { x: [], y: [] };
      if (value) {
        value.map((item, index) => {
          let [res] = Object.entries(item);
          this.dataList.x.push(res[0].slice(first, end));
          this.dataList.y.push(res[1]);
        });
      }
    },
    changeDay(value) {
      this.timeValue = value;
      this.getChartData();
    },
    getChartData() {
      if (this.timeValue == "day") {
        this.loadData(this.air.historicalDay, 10, 13);
      } else if (this.timeValue == "month") {
        this.loadData(this.air.historicalMonth, 8, 11);
      } else {
        this.loadData(this.air.historicalYear, 5, 8);
      }
    },
  },
};
</script>
